import React from 'react';
import { Text } from 'react-native';

// Mock for react-native-vector-icons/Ionicons
const Icon = ({ name, size = 24, color = '#000000', style, ...props }) => {
  const iconMap = {
    home: '🏠',
    'home-outline': '🏠',
    calendar: '📅',
    'calendar-outline': '📅',
    person: '👤',
    'person-outline': '👤',
    book: '📖',
    'book-outline': '📖',
    heart: '❤️',
    'heart-outline': '♡',
    share: '📤',
    'share-outline': '📤',
    bookmark: '🔖',
    'bookmark-outline': '🔖',
    notifications: '🔔',
    'notifications-outline': '🔔',
    menu: '☰',
    close: '✕',
    'arrow-back': '←',
    'arrow-forward': '→',
    'chevron-back': '‹',
    'chevron-forward': '›',
    play: '▶️',
    pause: '⏸️',
    stop: '⏹️',
    refresh: '🔄',
    search: '🔍',
    add: '+',
    remove: '−',
    checkmark: '✓',
    'close-circle': '✕',
    information: 'ℹ️',
    warning: '⚠️',
    alert: '❗',
    settings: '⚙️',
    cog: '⚙️',
    star: '⭐',
    'star-outline': '☆',
  };

  const iconContent = iconMap[name] || '□';

  return (
    <Text style={[{ fontSize: size, color, lineHeight: size }, style]} {...props}>
      {iconContent}
    </Text>
  );
};

export default Icon;
